<template>
    <div id="sales-list-container">
        <div v-if="!isMobile">
			<table class="sales-list" v-if=" cashierSalesReports.length > 0">
				<tr class="header-row sticky">
					<th class="gray">Full Name</th>
					<th class="gray">Cashier Name</th>
					<th class="green">Cash In Count</th>
					<th class="green">Cash In value COC</th>
					<th class="soft-blue">Cash Out Count</th>
					<th class="soft-blue">Cash Out value COC</th>
					<th class="darker-lavender">Total</th>
				</tr>
				<tr class="data-row" v-for="(item, index) in cashierSalesReports" :key="index" :value="item.id">
					<td class="center-align">{{ item.nameFirst }} {{ item.nameLast }} {{ item.nameLast2 }}</td>
					<td class="left-align">{{ item.displayName }}</td>
					<td class="right-align">{{ item.cashInCount }}</td>
					<td class="right-align">{{ systemCurrencyTool.formatCurrency(item.cashInValueCOC, systemWholeOrFull) }}</td>
                    <td class="right-align">{{ item.cashOutCount }}</td>
                    <td class="right-align">{{ systemCurrencyTool.formatCurrency(item.cashOutValueCOC, systemWholeOrFull) }}</td>
					<td class="right-align" :class="item?.totalHold.sign ? '' : 'negative'">
						{{ systemCurrencyTool.formatCurrency(item?.totalHold.value, systemWholeOrFull) }}
					</td>
				</tr>
				<tr class="total-row">

					<td class="center-align" colspan="2">Total</td>
                    <td class="right-align">{{ totals.cashInCountTotal}}</td>
					<td class="right-align">{{ systemCurrencyTool.formatCurrency(totals.cashInTotal, systemWholeOrFull) }}</td>
                    <td class="right-align">{{ totals.cashOutCountTotal }}</td>
					<td class="right-align">{{ systemCurrencyTool.formatCurrency(totals.cashOutTotal, systemWholeOrFull) }}</td>
					<td class="right-align">{{ systemCurrencyTool.formatCurrency(totals.sumTotalHolds, systemWholeOrFull) }}</td>
				</tr>
			</table>
			<div v-else>
				<h2 class="no-records">No Cashier Sales Reports</h2>
			</div>
		</div>

    </div>
	
</template>

<script>
export default {
	name: "CashierSalesReportTable",
	inheritAttrs: false,
	props: {
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		systemSettings: Object,
		isMobile: Boolean,
        cashierSalesReports: Array,
        totals: Object,
	},
	data() {
		return {
			systemFull: this.systemCurrencyTool.displayType.full,
			systemWholeOrFull: this.systemCurrencyTool.displayType.wholeOrFull,
		};
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#sales-list-container {
    position: relative;
	margin-bottom: 15px;
	padding: 15px;
	background-color: #ddd;
}
.sales-list {
	width: 100%;
	text-align: left;
	border-collapse: collapse;
	margin-bottom: 35px;
}

.sales-list th,
.sales-list td {
	border: 1px #000 solid;
	padding: 5px 10px;
}

.sales-list tr.data-row {
	color: #000;
}

.sales-list tr:nth-child(2n) {
	background-color: #bfbfbf;
}

.header-row th {
	border-color: #fff;
}

.sales-list tr:nth-child(2) th {
	border-color: #fff #fff #000;
}

.sales-list tr.total-row {
	font-weight: bold;
	background-color: #000;
	color: #fff;
}

.gray {
	background-color: #525252;
}

.green {
	background-color: #077607;
}

.med-orange {
	background-color: #bd7222;
}

.soft-blue {
	background-color: #5579a5;
}

.darker-lavender {
	background-color: #2c4feb;
}

.no-records {
	color: #000;
}

.right-align {
	text-align: right;
}

.left-align {
	text-align: left;
}

.center-align {
	text-align: center;
}
.negative {
	background-color: #ffffbd;
	color: #f00;
	font-weight: bold;
}

.total-row-mobile {
	background-color: black;
}

.text-black {
	color: black;
}

.disabled-section {
	background-color: darkgray;
	color: red;
}

</style>
